const CONST = require('plugin_frontend_core/constants');
const Swiper = require('swiper').default;
const Thumbs = require('swiper').Thumbs;
const Pagination = require('swiper').Pagination;
const Navigation = require('swiper').Navigation;

Swiper.use([Thumbs, Pagination, Navigation]);

const selectors = {
    storeCarouselMain: '.js-store-images-main',
    storeCarouselThumbs: '.js-store-images-thumbs',
    storeCarouselItem: '.js-store-images-item',
    userInputedImages: '.js-user-inputed-images',
    storeImageLink: '.js-store-image-link'
};

const classes = {
    lazyload: 'lazyload',
    lazyloaded: 'lazyloaded',
    lazyloading: 'lazyloading'
};

/**
 * Replace all img elements from the user with an img element on the main image, but keep the
 * src, alt and title.
 * @param {JQuery} $userInput - any div containing images
 * @param {Element} originalInput - image div used for the carousel
 */
function replaceUserWithOriginal($userInput, originalInput) {
    let $originalInput = $(originalInput);
    let processedInput = [];

    $userInput.find(CONST.selectors.img).each(function (index, userImage) {
        let $userImage = $(userImage);
        if ($userImage.length) {
            let $clonedOriginalInput = $originalInput.clone();
            let $originalImage = $clonedOriginalInput.find(CONST.selectors.img);
            let $link = $originalImage.closest(selectors.storeImageLink);
            let $slide = $originalImage.closest(selectors.storeCarouselItem);

            if ($originalImage.length) {
                // $originalImage was already manipulated because of lazyload class
                $originalImage.removeAttr(CONST.attributes.src);
                $originalImage.removeClass(classes.lazyloaded);
                $originalImage.removeClass(classes.lazyloading);
                $originalImage.addClass(classes.lazyload);

                $originalImage.attr(`data-${CONST.attributes.src}`, $userImage.attr(CONST.attributes.src));
                $originalImage.attr(CONST.attributes.alt, $userImage.attr(CONST.attributes.alt));
                $originalImage.attr(CONST.attributes.title, $userImage.attr(CONST.attributes.title));

                // This is needed for photoswipe to work with the store images. It replaces the anchor href, with the src of the user input image
                $link.attr(CONST.attributes.href, $userImage.attr(CONST.attributes.src));

                // Update Swiper index value
                $clonedOriginalInput.attr('data-swiper-index', 1)
                $slide.attr('data-swiper-index', index + 1)

                processedInput.push($clonedOriginalInput);
            }
        }
    });

    $userInput.replaceWith(processedInput);
}

/**
 * Find user inputed images and replace them with a proper way
 * image element should be formatted in order to appear in the carousel.
 */
function processUserInputedImages() {
    const $featuredUserInputs = $(`${selectors.storeCarouselMain} ${selectors.userInputedImages}`);
    const $featuredHeroInput = $(`${selectors.storeCarouselMain} ${selectors.storeCarouselItem}`);
    const $thumbnailsUserInputs = $(`${selectors.storeCarouselThumbs} ${selectors.userInputedImages}`);
    const $thumbnailsHeroInput = $(`${selectors.storeCarouselThumbs} ${selectors.storeCarouselItem}`);

    replaceUserWithOriginal($featuredUserInputs, $featuredHeroInput[0]);
    replaceUserWithOriginal($thumbnailsUserInputs, $thumbnailsHeroInput[0]);
}

/**
 * Adds attribute to slides before and after the previous and next slides, in order to select them in CSS
 */
function addAttrToVisibleSlides() {
    const brandSlider = $('.js-brand-slider')[0].swiper;
    const activeSlide = $(brandSlider.slides[brandSlider.activeIndex]);
    const nextSlide = $(brandSlider.slides[brandSlider.activeIndex + 1]);
    const prevSlide = $(brandSlider.slides[brandSlider.activeIndex - 1]);

    brandSlider.slides.removeAttr('data-visible-slide');

    if (activeSlide.length) {
        activeSlide.attr('data-visible-slide', 0);
    }

    if (nextSlide.length) {
        const afterNextSlide = $(brandSlider.slides[brandSlider.activeIndex + 2]);
        const afterAfterNextSlide = $(brandSlider.slides[brandSlider.activeIndex + 3]);

        nextSlide.attr('data-visible-slide', 1);

        if (afterNextSlide.length) {
            afterNextSlide.attr('data-visible-slide', 2);
        }

        if (afterAfterNextSlide.length) {
            afterAfterNextSlide.attr('data-visible-slide', 3);
        }
    }

    if (prevSlide.length) {
        const beforePrevSlide = $(brandSlider.slides[brandSlider.activeIndex - 2]);
        const beforeBeforePrevSlide = $(brandSlider.slides[brandSlider.activeIndex - 3]);

        prevSlide.attr('data-visible-slide', -1);

        if (beforePrevSlide.length) {
            beforePrevSlide.attr('data-visible-slide', -2);
        }

        if (beforeBeforePrevSlide.length) {
            beforeBeforePrevSlide.attr('data-visible-slide', -3);
        }
    }
}

function initStoreSwiper() {
    if ( $('.js-store-slider').length > 0 ) {
        processUserInputedImages();

        let storeThumbsSwiper = new Swiper('.js-store-thumbs-slider', {
            loop: false,
            direction: 'vertical',
            grabCursor: true,
            spaceBetween: 15,
            slidesPerView: 'auto',
            observer: true,
            watchOverflow: true
        });

        let storeSwiper = new Swiper('.js-store-slider', {
            loop: false,
            centerInsufficientSlides: false,
            grabCursor: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            observer: true,
            pagination: {
                el: '.swiper-pagination'
            },
            thumbs: {
                swiper: storeThumbsSwiper
            }
        });
    }

    if ( $('.js-brand-slider').length > 0 ) {

        var $nextEl = '.js-brand-slider + .swiper-navigation .swiper-button-next';
        var $prevEl = '.js-brand-slider + .swiper-navigation .swiper-button-prev';

        let brandSwiper = new Swiper('.js-brand-slider', {
            centeredSlides: true,
            grabCursor: true,
            loop: true,
            slidesPerView: 'auto',
            loopedSlides: 5,
            watchOverflow: true,
            navigation: {
                nextEl: $nextEl,
                prevEl: $prevEl
            },
            on: {
                slideChange: function() {
                    addAttrToVisibleSlides();
                }
            }
        });

        addAttrToVisibleSlides();

    }
}

/**
* Initializes the file
*/
function init() {
    $(document).ready(() => {
        initStoreSwiper();
    });
}

module.exports = {
    init: init
};
